var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":"","justify":"center","align":"center"}},[_c('v-col',[_vm._v("Page NotFound")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }